/** Gets whether or not GLG CM Shared runtime/API appears to be loaded. */
export const isCmSharedLoaded = () => typeof window.GLG !== 'undefined' && typeof window.GLG.Cmx !== 'undefined';

